import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from "react-redux";
import employeeService from '../../../services/Employee.service'

import { Col } from '@amzn/stencil-react-components/layout'
import { Table } from '@amzn/stencil-react-components/table'
import { H2, Text } from '@amzn/stencil-react-components/text'

class BrokerComparisonTable extends Component {
  convertToTitleCase = (str) => {
    return str[0].toUpperCase() + str.slice(1).toLowerCase();
  }

  addStyleToList = (data) => {
    const unorderedListWithStyle = '<ul style="list-style-type: disc; padding-left: 40px;">';

    data.forEach((item) => {
      item.values.map((value, index) => {
        item.values[index] = value.replace("<ul>", unorderedListWithStyle);
      });
    });
    return data;
  }

  brokerDataCell = (data) => {
    return (<Text dangerouslySetInnerHTML={{ __html: data.data}}/>);
  };

  createTableColumns = (category, brokers) => {
    const width = 100 / (brokers.length + 1);

    const columns = [
      {header: this.convertToTitleCase(category.title), accessor: ({ data }) => data.name, width: `${width}%`},
    ];

    brokers.map((broker, index) => (
      columns.push({header: broker.name, accessor: ({ data }) => data.values[index], cellComponent: this.brokerDataCell, width: `${width}%`})
    ))
    return columns;
  };

  render() {
    const { t, categories, brokers } = this.props;

    return (
      <Col gridGap="S400">
        <H2 id="table-label">{t("AvailableBrokers.BrokerComparisonTitle")}</H2>
        <Col gridGap="S300">
          {categories.map((category, index) => (
            <Table key={"ComparisonTable_" + index} columns={this.createTableColumns(category, brokers)} data={this.addStyleToList(category.vars)}/>
          ))}
        </Col>
      </Col>
    );
  }
}

const mapState = state => ({
  categories: employeeService.mapToBrokerComparisonUI(state.static_content.broker_info, false),
  brokers: state.static_content.broker_info.map(broker_entry => broker_entry.broker),
  employee: state.employee
});

export default connect(mapState, null)(withTranslation('translationsV2')(BrokerComparisonTable));
